import { withInstall } from '@hd-front-end/utils'
import Pagination from './src/pagination'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElPagination: SFCWithInstall<typeof Pagination> =
  withInstall(Pagination)
export default ElPagination

export * from './src/pagination'
export * from './src/constants'
